import { TableCellProps } from "@mui/material";

export const headers: { label: string; align?: TableCellProps["align"] }[] = [
  { label: "Nome do motorista" },
  { label: "E-mail" },
  { label: "Status do usuário" },
  { label: "Clientes vinculados", align: "center" },
  { label: "" },
];

export const linkHeaders = [
  { id: "clients", label: "Clientes" },
  { id: "lastSchedule", label: "Último carregamento" },
  { id: "emptyness", label: "" },
];

export const tabsLinkModal: Array<{ label: string }> = [
  { label: "Incluir" },
  { label: "Excluir" },
];
